module.exports = " <a href class=\"{{$ctrl.parentHasCheckedChild ? 'active' : ''}}\"> <checkboxes show-with=$ctrl.parentHasCheckedChild></checkboxes> <div class=information-container> <i class=\"td-icon-sm icon-{{$ctrl.solutionDictionaryLookup($ctrl.parentSolution.key, 'icon')}}\"></i> <div> <p class=strong>{{$ctrl.parent.name}}</p> <p ng-show=$ctrl.parent.summary> {{$ctrl.parent.summary}} </p> <p ng-hide=$ctrl.parent.summary> {{$ctrl.childSolutionsAsText()}} </p> </div> </div> </a> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/search-form/visual-picker/visualPicker.html
// module id = 622
// module chunks = 0